import { getThresholdPlanListFetch } from '@/api/orderMonitor'
import { ref, onBeforeMount } from 'vue'

export default function () {
  const thresholdPlanList = ref([])
  const getThresholdPlanList = async () => {
    try {
      const { code, data } = await getThresholdPlanListFetch()
      if (code === '0') {
        thresholdPlanList.value =
          data?.thresholdSchemeList?.map((item: Record<string, any>) => {
            return {
              ...item,
              label: item.schemeName,
              value: item.schemeId,
            }
          }) ?? []
      }
    } catch (error) {
      console.log(error)
    }
  }

  onBeforeMount(() => {
    getThresholdPlanList()
  })

  return {
    thresholdPlanList,
    getThresholdPlanList,
  }
}
